import gql from 'graphql-tag'

const   FAKE_BOOKINGS_SUBSCRIPTIONS = gql`subscription {
    fake_bookings (order_by: {day_date: desc, slot: {start_time: asc}}){
        id
        user_id
        slot_id
        points_cost
        day_date
        uuid
        attended
        slot{
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash            
            capacity
            instructor_name
            registered
            link
            males
            females
            bookings_counts{
                booking_day_date
                registered
            }
            class{
                id
                name
                instructor_name
                level
                business_id
                image_1
                image_2
                image_3
                image_4
                image_5
                image_6
                image_7
                image_8
                is_online
                description
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
                business{
                    id
                    name
                    logo
                    is_private
                }
                categories{
                    category{
                        id
                        name
                    }
                }
                }
                instructor{
                    id
                    name
                    logo
                }
        }
    }
}`;

const BOOKINGS_SUBSCRIPTIONS = gql`subscription {
    bookings(order_by: {day_date: desc, slot: {start_time: asc}}){
        id
        user_id
        slot_id
        points_cost
        day_date
        uuid
        attended
        slot{
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash            
            capacity
            instructor_name
            registered
            link
            males
            females
            bookings_counts{
                booking_day_date
                registered
            }
            class{
                id
                name
                instructor_name
                level
                business_id
                image_1
                image_2
                image_3
                image_4
                image_5
                image_6
                image_7
                image_8
                is_online
                description
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
                business{
                    id
                    name
                    logo
                    is_private
                }
                categories{
                    category{
                        id
                        name
                    }
                }
                }
                instructor{
                    id
                    name
                    logo
                }
        }
    }
}`;

const BOOKINGS_COUNTS = gql`subscription{
        bookings_count{
            booking_day_date
            registered
        }
}`;

const SLOT_SUBSCRIPTION = gql`subscription{
    slot(order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_MALES_SUBSCRIPTION = gql`subscription ($todayDate: date!){
    slot(
       where:  {_and:[
        {end_date: {_gte: $todayDate}}
        {males: {_eq: true}},
        {class: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
        ]}}}
        ]},
         order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_FEMALES_SUBSCRIPTION = gql`subscription ($todayDate: date!){

    slot(where:{_and:[
            {end_date: {_gte: $todayDate}}
            {females: {_eq: true}},
            {class: {business: {_and:[
                {verified: {_eq: true}},
                {brand: {verified: {_eq: true}}}
            ]}}}
            ]},
            order_by:{start_date: asc, start_time: asc}) {

        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_MIXED_ONLY_SUBSCRIPTION = gql`subscription ($todayDate: date!){
    slot(where: {_and:[
        {end_date: {_gte: $todayDate}},
        {males: {_eq: true}},
        {females: {_eq: true}},
        {class: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
        ]}}}
    ]}, order_by:{start_date: asc, start_time: asc}) 
    {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const USER_INFO_SUBSCRIPTION = gql`subscription{
    user{
        id
        name
        phone
        is_deactivated
        coins
        verified
    }
}`;


const NOTIFICATIONS_SUBSCRIPTION = gql `subscription{
    
    user_notification(order_by: {updated_at: desc}){
        
        id
        message
        read
    }
}
`;

const BUSINESS_NOTIFICATIONS_SUBSCRIPTION = gql `subscription($businessId: Int!){
    
    business_notification(where:{business_id:{_eq: $businessId}}){
        
        id
        message
        read
    }
}
`;


export default {

    fake_bookings_subscriptions: FAKE_BOOKINGS_SUBSCRIPTIONS,

    bookings_subscriptions: BOOKINGS_SUBSCRIPTIONS,

    slot_subscription: SLOT_SUBSCRIPTION,

    slot_gender_subscription: function(gender){

        if(gender == 'male'){

            return SLOT_MALES_SUBSCRIPTION;
        }
        else{

            // console.log(`in female`);
            return SLOT_FEMALES_SUBSCRIPTION;
        }
    },

    slot_mixed_only_subscription: SLOT_MIXED_ONLY_SUBSCRIPTION,

    user_info_subscription: USER_INFO_SUBSCRIPTION,

    bookings_count: BOOKINGS_COUNTS,

    notificaions_subscription: NOTIFICATIONS_SUBSCRIPTION,

    business_notifications_subscription : BUSINESS_NOTIFICATIONS_SUBSCRIPTION,

}